export default [
  {
    path: 'shiftManage',
    component: () => import(/* webpackChunkName: "shift-manage" */ '@/pages/scheduling/ShiftManage'),
    meta: { title: '班次管理', cate: '排班打卡' }
  },
  {
    path: 'attendanceGroup',
    component: () => import(/* webpackChunkName: "attendance-group" */ '@/pages/scheduling/AttendanceGroup'),
    meta: { title: '打卡管理', cate: '排班打卡' }
  },
  {
    path: 'attendanceClockRecord',
    component: () => import(/* webpackChunkName: "attendance-clock-record" */ '@/pages/scheduling/AttendanceClockRecord'),
    meta: { title: '打卡记录', cate: '排班打卡' }
  }
]
